import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { CoreModule } from './modules/core/core.module';
import { MaterialModule } from './modules/material/material.module';
import { MainLayoutModule } from './modules/main-layout/main-layout.module';
import { SharedModule } from './modules/shared/shared.module';
import { DynamicFormsModule } from './modules/dynamic-forms-fw/dynamic-forms-fw.module';
import { DynamicFormsRenderModule } from './modules/dynamic-forms-fw-render/dynamic-forms-fw-render.module';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({ declarations: [
        AppComponent,
        AdminLayoutComponent,
        LoginComponent,
        ResetPasswordComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MainLayoutModule,
        RouterModule,
        AppRoutingModule,
        AdminLayoutModule,
        CoreModule,
        MaterialModule,
        SharedModule,
        DynamicFormsModule,
        DynamicFormsRenderModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // enabled: true,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable'
        })
        // ClinicalNoteModule,
    ], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
